module.exports = __webpack_public_path__ + "static/media/Niveau_elN6_2_1024810.ceb0d9df.png";